<template>
  <panel title="Edycja aktu prawnego">
    <w-input :model="$schema.title" />

    <w-textarea :model="$schema.description" />

    <template v-if="$schema.htmls.$items.length">
      <w-wysiwyg
        v-for="(item, index) of $schema.htmls.$items"
        :key="'wyswig_' + index"
        class="mb-2"
        :model="item.$item"
        :config="config"
      />
    </template>

    <w-wysiwyg v-else class="mb-2" :model="$schema.html" :config="config" />

    <div slot="footer">
      <w-button class="btn-danger mr-2" text="Anuluj edycję" @click="goToDocumentation" />

      <post-form
        class="mr-2"
        icon="fal fa-cloud-download mr-2"
        button-class="btn-secondary"
        text="Pobierz pdf"
        :fields="viewFormFields"
        :url="pdfUrl"
      />

      <w-button class="btn-secondary mr-2" text="Zaktualizuj załącznik" @click="updateAttachment" />
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { previewMixin } from '@/mixins/preview';
import { renderMixin } from '@/mixins/render';
import schema from '@/schemas/editGenerated.schema';
import { tryParseInt } from '@/utils/number';

// @vuese
// Edycja HTML'a widoku
// @group Document
export default {
  components: { Panel, PostForm },
  mixins: [formMixin, renderMixin, notificationsMixin],
  props: {
    // Pozostałe dane
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  schema,
  data() {
    return {
      model: {},
      config: { allowedContent: true, height: 450 }
    };
  },

  computed: {
    ...mapState({
      attachment: function(state) {
        if (this.$route.params.documentId) {
          return state.document.attachment.data;
        }
        return state.procedure.attachment.data;
      },
      documentIndex: state => state.documentIndex.data
    }),
    attachmentId() {
      return this.$route.params.attachmentId;
    },
    viewFormFields() {
      const data = {
        ...this.$schema.$getData(),
        data: this.attachment.metadata?.data?.model,
        document: this.$route.params.documentId && this.documentIndex
      };
      return Object.keys(data).map(key => ({ name: key, value: data[key] }));
    },
    pdfUrl() {
      return this.getPdfFromHtmlUrl(this.viewId);
    },
    viewId() {
      return this.attachment.viewId;
    }
  },
  mounted() {
    this.$schema.title.$setData(this.attachment.name);
    this.$schema.description.$setData(this.attachment.description);
    if (this.attachment.metadata.edit.htmls && this.attachment.metadata.edit.htmls.length) {
      this.$schema.htmls.$setData(this.attachment.metadata.edit.htmls, undefined, true);
    } else if (this.attachment.metadata.edit.html) {
      this.$schema.html.$setData(this.attachment.metadata.edit.html);
    }
  },
  methods: {
    // @vuese
    // Zapisywanie wyedytowanego HTMLa do załącznika
    updateAttachment() {
      if (!this.$schema.$validateAll().length) {
        this.$store
          .dispatch(
            (this.$route.params.documentId ? 'document' : 'procedure') + '/attachment/updateEditedHtmlAttachment',
            {
              attachmentId: tryParseInt(this.attachmentId),
              ...this.$schema.$getData()
            }
          )
          .then(() => {
            this.notifySuccess(Successes.ATTACHMENT_SAVED);
            this.goToDocumentation();
          })
          .catch(err => this.notifyError(Errors.ERROR_TRY_AGAIN_LATER));
      } else {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
      }
    },
    // @vuese
    // Powrót do `documentGenerate`
    goToDocumentation() {
      this.$router.push({ name: this.attachment.entityType + 'Documentation' });
    }
  }
};
</script>
